export const EVENT_LOGIN = 'login'